var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "billing-period-container" },
    _vm._l(_vm.periods, function (period, key) {
      return _c(
        "div",
        {
          key: key,
          staticClass: "billing-period-button",
          class: { active: key === _vm.value },
          on: {
            click: function ($event) {
              return _vm.$emit("input", key)
            },
          },
        },
        [
          _vm._v("\n        " + _vm._s(period) + " "),
          _vm.discount[key] > 0
            ? _c("span", [_vm._v(_vm._s(_vm.discount[key]) + "%")])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }